export default () => ({
    hidden: {
        height: 0,
        overflow: 'hidden',
        visibility: 'hidden',
    },
});
